import React from 'react';
import { func, bool, string, node } from 'prop-types';

export const Header = ({ icon, title, subtitle, showCloseButton = true, onClose = () => {} }) => {
  return (
    <header className="modal-header">
      {icon && (
        <div className="modal-header-icon">
          <img src={icon} alt="Title icon" />
        </div>
      )}
      <div className="title-wrapper">
        <div className="title">{title}</div>
        <div className="subtitle">{subtitle}</div>
      </div>
      {showCloseButton && (
        <button type="button" className="close-button" aria-label="Close" onClick={onClose}>
          <span aria-hidden="true">×</span>
        </button>
      )}
    </header>
  );
};

Header.propTypes = {
  icon: string,
  title: string,
  subtitle: string,
  showCloseButton: bool,
  onClose: func,
};

export const Body = ({ children }) => {
  return <main className="modal-body">{children}</main>;
};

Body.propTypes = {
  children: node,
};

export const Footer = ({ children }) => {
  return <footer className="modal-actions">{children}</footer>;
};

Footer.propTypes = {
  children: node,
};
